import { JointProposer } from "../drivers/driver-types";
import { Claim, Item } from "./repeater-types";

export const EMPTY_CLAIM: Claim = {
    type: null,
    is_settled: null,
    date: null,
    amount: null
};

export const EMPTY_JOINT_PROPOSER: JointProposer = {
    personal_details: {
        title: null,
        first_name: null,
        surname: null,
        date_of_birth: null
    }
};

export const EMPTY_ITEM: Item = {
    type: null,
    description: null,
    value: null
};
